var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/contentful/render-entries.j2"] = require( "macros/contentful/render-entries.j2" );
dependencies["macros/contentful-module-spacing.j2"] = require( "macros/contentful-module-spacing.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/contentful/split-module.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/contentful/render-entries.j2", false, "core/templates/macros/contentful/split-module.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("renderEntries")) {
var t_4 = t_1.renderEntries;
} else {
cb(new Error("cannot import 'renderEntries'")); return;
}
context.setVariable("renderEntries", t_4);
env.getTemplate("macros/contentful-module-spacing.j2", false, "core/templates/macros/contentful/split-module.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("getBottomMarginClasses")) {
var t_8 = t_5.getBottomMarginClasses;
} else {
cb(new Error("cannot import 'getBottomMarginClasses'")); return;
}
context.setVariable("getBottomMarginClasses", t_8);
var macro_t_9 = runtime.makeMacro(
[], 
["entry", "isSpecialtyShop", "isGiveawayModule", "entryloop", "isLazy"], 
function (kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("entry", kwargs.hasOwnProperty("entry") ? kwargs["entry"] : {});
frame.set("isSpecialtyShop", kwargs.hasOwnProperty("isSpecialtyShop") ? kwargs["isSpecialtyShop"] : false);
frame.set("isGiveawayModule", kwargs.hasOwnProperty("isGiveawayModule") ? kwargs["isGiveawayModule"] : false);
frame.set("entryloop", kwargs.hasOwnProperty("entryloop") ? kwargs["entryloop"] : runtime.contextOrFrameLookup(context, frame, "None"));
frame.set("isLazy", kwargs.hasOwnProperty("isLazy") ? kwargs["isLazy"] : false);
var t_10 = "";var t_11;
t_11 = runtime.contextOrFrameLookup(context, frame, "entry");
frame.set("module", t_11, true);
if(frame.topLevel) {
context.setVariable("module", t_11);
}
if(frame.topLevel) {
context.addExport("module", t_11);
}
t_10 += "\n    ";
var t_12;
t_12 = (lineno = 5, colno = 31, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "module"),"fields.isFlex",false]));
frame.set("isFlex", t_12, true);
if(frame.topLevel) {
context.setVariable("isFlex", t_12);
}
if(frame.topLevel) {
context.addExport("isFlex", t_12);
}
t_10 += "\n    ";
var t_13;
t_13 = (runtime.contextOrFrameLookup(context, frame, "isFlex")?"s-contentful-flex":"");
frame.set("flexFitClass", t_13, true);
if(frame.topLevel) {
context.setVariable("flexFitClass", t_13);
}
if(frame.topLevel) {
context.addExport("flexFitClass", t_13);
}
t_10 += "\n    ";
var t_14;
t_14 = (lineno = 7, colno = 43, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "module"),"fields.smallScreenDisplay",""]));
frame.set("smallScreenDisplay", t_14, true);
if(frame.topLevel) {
context.setVariable("smallScreenDisplay", t_14);
}
if(frame.topLevel) {
context.addExport("smallScreenDisplay", t_14);
}
t_10 += "\n    ";
var t_15;
t_15 = (lineno = 8, colno = 39, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "module"),"fields.stackedOnSmallScreen",false])) || runtime.contextOrFrameLookup(context, frame, "smallScreenDisplay") == "stacked";
frame.set("stackedOnSmall", t_15, true);
if(frame.topLevel) {
context.setVariable("stackedOnSmall", t_15);
}
if(frame.topLevel) {
context.addExport("stackedOnSmall", t_15);
}
t_10 += "\n    ";
var t_16;
t_16 = runtime.contextOrFrameLookup(context, frame, "smallScreenDisplay") == "slider";
frame.set("isMobileSlider", t_16, true);
if(frame.topLevel) {
context.setVariable("isMobileSlider", t_16);
}
if(frame.topLevel) {
context.addExport("isMobileSlider", t_16);
}
t_10 += "\n    ";
var t_17;
t_17 = (lineno = 10, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "module"),"fields.containsProductGrid",false]));
frame.set("containsProductGrid", t_17, true);
if(frame.topLevel) {
context.setVariable("containsProductGrid", t_17);
}
if(frame.topLevel) {
context.addExport("containsProductGrid", t_17);
}
t_10 += "\n\n    ";
var t_18;
t_18 = (runtime.contextOrFrameLookup(context, frame, "stackedOnSmall")?"s-stacked-on-small":"");
frame.set("stackedOnSmallClass", t_18, true);
if(frame.topLevel) {
context.setVariable("stackedOnSmallClass", t_18);
}
if(frame.topLevel) {
context.addExport("stackedOnSmallClass", t_18);
}
t_10 += "\n    ";
var t_19;
t_19 = (runtime.contextOrFrameLookup(context, frame, "isMobileSlider")?"c-contentful-mobile-slider js-contentful-mobile-slider":"");
frame.set("mobileSliderClass", t_19, true);
if(frame.topLevel) {
context.setVariable("mobileSliderClass", t_19);
}
if(frame.topLevel) {
context.addExport("mobileSliderClass", t_19);
}
t_10 += "\n    ";
t_10 += "\n\n    ";
t_10 += "\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isFlex") || runtime.contextOrFrameLookup(context, frame, "isMobileSlider")) {
t_10 += "\n        <div class=\"";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "flexFitClass"), env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "stackedOnSmallClass"), env.opts.autoescape);
t_10 += " ";
t_10 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "mobileSliderClass"), env.opts.autoescape);
t_10 += "\n            ";
t_10 += runtime.suppressValue((lineno = 19, colno = 35, runtime.callWrap(t_8, "getBottomMarginClasses", context, [runtime.contextOrFrameLookup(context, frame, "module"),runtime.contextOrFrameLookup(context, frame, "isSpecialtyShop")])), env.opts.autoescape);
t_10 += "\">\n    ";
;
}
t_10 += "\n\n    ";
frame = frame.push();
var t_22 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "module")),"fields")),"components");
if(t_22) {var t_21 = t_22.length;
for(var t_20=0; t_20 < t_22.length; t_20++) {
var t_23 = t_22[t_20];
frame.set("entry", t_23);
frame.set("loop.index", t_20 + 1);
frame.set("loop.index0", t_20);
frame.set("loop.revindex", t_21 - t_20);
frame.set("loop.revindex0", t_21 - t_20 - 1);
frame.set("loop.first", t_20 === 0);
frame.set("loop.last", t_20 === t_21 - 1);
frame.set("loop.length", t_21);
t_10 += "\n        ";
var t_24;
t_24 = runtime.contextOrFrameLookup(context, frame, "loop");
frame.set("moduleentryloop", t_24, true);
if(frame.topLevel) {
context.setVariable("moduleentryloop", t_24);
}
if(frame.topLevel) {
context.addExport("moduleentryloop", t_24);
}
t_10 += "\n\n        ";
t_10 += runtime.suppressValue((lineno = 25, colno = 22, runtime.callWrap(t_4, "renderEntries", context, [t_23,runtime.contextOrFrameLookup(context, frame, "module"),runtime.contextOrFrameLookup(context, frame, "entryloop"),runtime.contextOrFrameLookup(context, frame, "isSpecialtyShop"),runtime.contextOrFrameLookup(context, frame, "moduleentryloop"),runtime.contextOrFrameLookup(context, frame, "isLazy"),runtime.contextOrFrameLookup(context, frame, "isMobileSlider"),runtime.contextOrFrameLookup(context, frame, "containsProductGrid"),runtime.contextOrFrameLookup(context, frame, "isFlex")])), env.opts.autoescape);
t_10 += "\n    ";
;
}
}
frame = frame.pop();
t_10 += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "isFlex") || runtime.contextOrFrameLookup(context, frame, "isMobileSlider")) {
t_10 += "\n        </div>\n    ";
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("splitModule");
context.setVariable("splitModule", macro_t_9);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/contentful/split-module.j2"] , dependencies)